import {baseAemApi} from '@/services/api/base-aem-api';
import {mapProductPricingResponse} from '@/services/api/utils/product-pricing-response-mapper';

/**
 * RTK Query API for product pricing operations.
 * Targets the AEM same-origin servlet at /bin/esri/productpricing.
 * CSRF token handling and Authorization are managed by aemBaseApi.
 */
export const productPricingApi = baseAemApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Fetch product pricing data by posting a request payload.
     * @param {Object} requestBody - The request payload containing product paths and config
     * @returns {Promise<Object>} - A promise that resolves to the product pricing data
     */
    getProductPricing: builder.query({
      query: (requestBody) => ({
        url: '/bin/esri/productpricing',
        method: 'POST',
        body: requestBody,
      }),
      transformResponse: (response) => mapProductPricingResponse(response),
    }),
  }),
});

export const {useGetProductPricingQuery, useLazyGetProductPricingQuery} = productPricingApi;
